/**
 * Foundation images, as served by Gyrobase Imager.
 * @constructor
 * @param {string} url
 */
Foundation.Image = function (url) {
  /**
   * @private
   * @type {Foundation.URL}
   */
  this._url = new Foundation.URL(url);

  /**
   * @private
   * @type {number}
   */
  this._transformedWidth;

  /**
   * @private
   * @type {number}
   */
  this._transformedHeight;
};

/**
 * @return {Foundation.URL}
 */
Foundation.Image.prototype.url = function () {
  return new Foundation.URL(this._url.toString());
};

/**
 * @public
 * @return {{width:number, height:number}}
 */
Foundation.Image.prototype.dimensions = function () {
  return {"width": this._transformedWidth, "height": this._transformedHeight};
};

/**
 * @private
 * @param {number} width
 * @param {number} height
 */
Foundation.Image.prototype.setDimensions = function (width, height) {
  this._transformedWidth = width;
  this._transformedHeight = height;
};

/**
 * Parse the path of a Gyrobase Imager URL. Throws an error if string cannot
 * be parsed as a URL.
 * @param {string} url
 * @return {{fieldType:string, transformation:string, oid:string, fileName:string}}
 */
Foundation.Image.parseImagerUrl = function (url) {
  var origUrl = url.replace(/(\/imager\/(?:[^/]+\/)?[bu])\/[\w-]+/, "$1/original");
  url = `/${(new Foundation.URL(url)).pathAsArray().join("/")}`;
  var regex = new RegExp("/imager(?:/.*)?/+([ub])/+([^/]+)/+([^/]+)/*");
  var components = url.match(regex);
  if (!components) throw `Not a valid imager URL: ${url}`;
  var path = url.replace(regex, "");
  return {
    fieldType: components[1],
    transformation: components[2],
    oid: components[3],
    fileName: path,
    origUrl: origUrl
  };
};

// ---------------------------------------------------------------------
window["Foundation"]["Image"] = Foundation.Image;
Foundation.Image.prototype["url"] = Foundation.Image.prototype.url;
Foundation.Image.prototype["dimensions"] = Foundation.Image.prototype.dimensions;
